import { values } from 'mobx';

/*
##     ##    ###    ########  ##    ## ######## ########     ######   ########   #######  ##     ## ########
###   ###   ## ##   ##     ## ##   ##  ##          ##       ##    ##  ##     ## ##     ## ##     ## ##     ##
#### ####  ##   ##  ##     ## ##  ##   ##          ##       ##        ##     ## ##     ## ##     ## ##     ##
## ### ## ##     ## ########  #####    ######      ##       ##   #### ########  ##     ## ##     ## ########
##     ## ######### ##   ##   ##  ##   ##          ##       ##    ##  ##   ##   ##     ## ##     ## ##
##     ## ##     ## ##    ##  ##   ##  ##          ##       ##    ##  ##    ##  ##     ## ##     ## ##
##     ## ##     ## ##     ## ##    ## ########    ##        ######   ##     ##  #######   #######  ##

 ######   #######  ##     ## ##     ##    ###    ##    ## ########   ######
##    ## ##     ## ###   ### ###   ###   ## ##   ###   ## ##     ## ##    ##
##       ##     ## #### #### #### ####  ##   ##  ####  ## ##     ## ##
##       ##     ## ## ### ## ## ### ## ##     ## ## ## ## ##     ##  ######
##       ##     ## ##     ## ##     ## ######### ##  #### ##     ##       ##
##    ## ##     ## ##     ## ##     ## ##     ## ##   ### ##     ## ##    ##
 ######   #######  ##     ## ##     ## ##     ## ##    ## ########   ######
*/

const marketGroupCommands = (s) => ({
    // ##========================================================================================
    // ##                                                                                      ##
    // ##                                Update and put markers                                ##
    // ##                                                                                      ##
    // ##========================================================================================

    putUpdateMarkets({ dataSource = [], isFeatured = false, isCustom, isMatchInfoUpdate = false }) {
        dataSource.map(({ i: identifierNumber, o, dc, b, n, sn, coa }) => {
            if (s.markets.has(identifierNumber)) {
                /**** ~~ Update old ones from existing data ****/
                s.markets.get(identifierNumber).update({ o, dc, b, coa, sn }, isFeatured, isCustom);
            } else {
                /**** ~~ Fill new ones from existing data ****/
                s.markets.put({
                    id: identifierNumber,
                    columnCount: dc > 3 ? 1 : dc,
                    order: o,
                    name: n,
                    baseName: n,
                    shortName: sn,
                    canCashout: !!coa,
                    isCustom: isCustom,
                });
                /**** ~~ Fill bets of market ****/
                b && s.markets.get(identifierNumber).setBets(b, isCustom);
                s.markets.get(identifierNumber).marketName();
            }
        });
        if (!isFeatured && !isMatchInfoUpdate) {
            s.deleteOldMarkets({incomingMarkets: dataSource})
        }
    },

    // ##========================================================================================
    // ##                                                                                      ##
    // ##                                 Market groups updater                                ##
    // ##                                                                                      ##
    // ##========================================================================================

    update({ o: order, m: markets, n: name, sn: shortName }, isFeatured, isCustom, isMatchInfoUpdate = false) {
        if (order !== s.order && order !== 1) {
            s.order = order;
        }
        name && (s.name = name);
        shortName && (s.shortName = shortName);
        markets && s.putUpdateMarkets({ dataSource: markets, isFeatured, isCustom, isMatchInfoUpdate });
    },

    // ##========================================================================================
    // ##                                                                                      ##
    // ##                               Old markets deleter                                    ##
    // ##                                                                                      ##
    // ##========================================================================================

    deleteOldMarkets({ incomingMarkets }) {
        values(s.markets)
            .filter(({ id }) => !incomingMarkets.some(({ i }) => i === id))
            .map((oldMarket) => {
                const market = s.markets.get(oldMarket.id);
                if (market) {
                    market.removeItems();
                }
            });
    },
});

export default marketGroupCommands;
